import styled from "styled-components";
import { mobileChangeWidth } from "../../styles/theme";

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 18px;
`;

const FormItem = styled.div`
    display: flex;
    align-items: start;
    gap: 14px;
    margin-bottom: 18px;
    @media only screen and (max-width: ${mobileChangeWidth}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const FormLabel = styled.label`
    flex-shrink: 0;
    display: block;
    width: 140px;
    line-height: 40px;
    font-weight: 500;
    font-size: 18px;
    color: #222;
    text-align: right;
    @media only screen and (max-width: ${mobileChangeWidth}) {
        width: 100%;
        font-size: 14px;
        line-height: 14px;
        text-align: left;
    }
`;

const FormInput = styled.input`
    flex: 1;
    height: 38px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 0 12px;
    font-size: calc(0.7rem + 0.2vw);
`;

const FormSelect = styled.select`
    flex: 1;
    height: 38px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 0 12px;
    font-size: calc(0.7rem + 0.2vw);
`;

const FormButton = styled.button`
    background: #ff8116;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 0 12px;
`;

export { Form, FormItem, FormLabel, FormInput, FormButton, FormSelect };